import { Component, Input, OnInit } from '@angular/core';
import { ApplicationListDetail } from '../../model/application/application-list-detail.model';
import { Observable } from 'rxjs/Observable';
import { LogoService } from '../../../../core/services/logo.service';

/**
 * Component to display Application name and logo.
 *
 * https://stackoverflow.com/a/45666313/4420532
 */
@Component({
    selector: 'ssf-app-brand-identifier',
    template: `
        <ssf-brand-identifier [name]="application.name" [description]="application.tpp.name"
                              [logo]="(logo$ | async)" [logoAlt]="'APPLICATIONS.LOGO' | translate">
        </ssf-brand-identifier>
    `
})
export class AppBrandIdentifierComponent implements OnInit {
    @Input()
    public application: ApplicationListDetail;
    public logo$: Observable<Blob>;

    constructor(private logoService: LogoService) {}

    ngOnInit(): void {
        this.logo$ = this.logoService.loadApplicationImage(this.application.appId);
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/applications/components/app-brand-identifier/app-brand-identifier.component.ts